import React from 'react';

// TODO: Remove when the reactivation flow has been added.
const CancelNotice = () => (
  <p className="text-sm">Your subscription has been canceled.</p>
);

export default CancelNotice;
